<template>
  <span>
    <span v-if="$store.state.main.game.enableSuggestions">
      <card shadow>
        <small>
          <strong>{{ $t("bolded") }}</strong> {{ $t("text1") }}
        </small>
        <span class="button-example">
          <font-awesome-icon transform="right-6" icon="lightbulb" />
          &nbsp;
        </span>
        <small>
          &nbsp;
          {{ $t("text2") }}
        </small>
      </card>
    </span>
    <br />
  </span>
</template>

<script>
export default {
  data: function() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style scoped>
.button-example {
  width: 30px;
  height: 30px;
  background-color: #2dce89;
  color: #fff;
  border-radius: 20px;
  text-align: center;
  box-shadow: 2px 2px 3px #999;
  white-space: nowrap;
}
</style>

<i18n>
  {
    "en": {
      "bolded": "Write down your ideas!",
      "text1": "By pressing the button in the bottom left corner",
      "text2": "you can write down ideas and development suggestions that come to mind during the simulation. Saved ideas are immediately visible to the facilitator. In addition, the ideas and names of the people who wrote them down are visible to all participants in the report created at the end of the simulation."
    },
    "fi": {
      "bolded": "Kirjoita ideat talteen!",
      "text1": "Painamalla vasemmassa alakulmassa näkyvää nappia",
      "text2": "voit kirjata ylös simulaation aikana mieleesi tulevia ideoita ja kehitysehdotuksia. Tallennetut ideat näkyvät välittömästi pelinjohtajalle. Lisäksi ideat ja niiden kirjoittajien nimet näkyvät kaikille osallistujille simulaation lopuksi luotavassa raportissa. Voitte raporttia käsitellessä päättää, mitä ideoita otatte käyttöön."
    },
    "sv": {
      "bolded": "Skriv ner dina idéer!",
      "text1": "Genom att trycka på knappen i det nedre vänstra hörnet",
      "text2": "du kan skriva ner idéer och utvecklingsförslag som du tänker på under simuleringen. Sparade idéer är omedelbart synliga för handledaren. Dessutom är idéerna och namnen på personerna som skrev ner dem synliga för alla deltagare i rapporten som skapades i slutet av simuleringen. Du kan bestämma vilka idéer du vill ta med dig när du diskuterar rapporten."
    },
    "de": {
      "bolded": "Schreiben Sie Ihre Ideen auf!",      
      "text1": "Durch Drücken der Schaltfläche in der unteren linken Ecke",
      "text2": "Sie können Ideen und Entwicklungsvorschläge aufschreiben, die Ihnen während der Simulation in den Sinn kommen. Gespeicherte Ideen sind für den Moderator sofort sichtbar. Darüber hinaus sind die Ideen und Namen der Personen, die sie niedergeschrieben haben, in dem am Ende der Simulation erstellten Bericht für alle Teilnehmer sichtbar."
    },
   "ko": {
      "bolded": "키르조이타 아이디어 탤틴!",          
      "text1": "왼쪽 하단 모서리에 있는 버튼을 눌러",
      "text2": "를 통해 시뮬레이션 중에 떠오르는 아이디어와 개발 제안을 적을 수 있습니다. 저장된 아이디어는 진행자가 즉시 볼 수 있습니다. 또한 시뮬레이션이 끝나면 작성된 보고서에서 모든 참가자가 아이디어와 이를 기록한 사람의 이름을 볼 수 있습니다."
    }
  }
  </i18n>
